import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import axios from 'axios';
import { API_URL } from '../config/api';
import { useAuth } from '../context/AuthContext';
import './Wallet.css';

const Wallet = () => {
  const { t } = useTranslation();
  const { user } = useAuth();
  const [wallet, setWallet] = useState(null);
  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (user) {
      fetchWallet();
      fetchTransactions();
    }
  }, [user]);

  const fetchWallet = async () => {
    try {
      const response = await axios.get(`${API_URL}/wallet/me`);
      setWallet(response.data);
    } catch (error) {
      console.error('Error fetching wallet:', error);
    } finally {
      setLoading(false);
    }
  };

  const fetchTransactions = async () => {
    try {
      const response = await axios.get(`${API_URL}/wallet/me/transactions`);
      setTransactions(response.data.transactions || []);
    } catch (error) {
      console.error('Error fetching transactions:', error);
    }
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleString();
  };

  if (loading) {
    return (
      <div className="wallet-container">
        <div className="container">
          <div className="loading-spinner">{t('account.loading') || 'Loading...'}</div>
        </div>
      </div>
    );
  }

  return (
    <div className="wallet-container">
      <div className="container">
        <h1>{t('account.wallet') || 'Wallet'}</h1>

        <div className="wallet-balance-card">
          <div className="wallet-balance-header">
            <h2>{t('account.balance') || 'Balance'}</h2>
            <div className="wallet-balance-amount">
              €{wallet?.balance?.toFixed(2) || '0.00'}
            </div>
          </div>
        </div>

        <div className="wallet-transactions">
          <h2>{t('account.transactions') || 'Transaction History'}</h2>
          {transactions.length === 0 ? (
            <div className="no-transactions">
              {t('account.noTransactions') || 'No transactions yet'}
            </div>
          ) : (
            <div className="transactions-list">
              {transactions.map((transaction, index) => (
                <div key={index} className={`transaction-item ${transaction.type}`}>
                  <div className="transaction-info">
                    <div className="transaction-type">
                      {transaction.type === 'credit' && <i className="fas fa-plus-circle"></i>}
                      {transaction.type === 'debit' && <i className="fas fa-minus-circle"></i>}
                      {transaction.type === 'refund' && <i className="fas fa-undo"></i>}
                      <span className="transaction-type-label">
                        {transaction.type === 'credit' && (t('account.credit') || 'Credit')}
                        {transaction.type === 'debit' && (t('account.debit') || 'Debit')}
                        {transaction.type === 'refund' && (t('account.refund') || 'Refund')}
                      </span>
                    </div>
                    <div className="transaction-description">
                      {transaction.description || t('account.transaction') || 'Transaction'}
                    </div>
                    <div className="transaction-date">
                      {formatDate(transaction.createdAt)}
                    </div>
                  </div>
                  <div className={`transaction-amount ${transaction.type}`}>
                    {transaction.type === 'credit' || transaction.type === 'refund' ? '+' : '-'}
                    €{transaction.amount.toFixed(2)}
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Wallet;
